<template>
  <div
    class="partsLocation-bd tb"
    v-if="funcView.part_location_list"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item>
          <el-button
            type="primary"
            v-if="funcView.part_location_add"
            @click="addPartItem"
          >{{ funcView.part_location_add }}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0;">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            :placeholder="i18n.placeholder_search"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        height="100%"
        index
        :data="tableList"
        :column="tableColumn"
        @sort="sortChange"
        @filter="filterChange"
        :slots="['partInfo', 'action']"
      >
        <template v-slot:partInfo="scope">
          <el-popover
            @show="checkPartDetail(scope.row)"
            placement="top-start"
            trigger="click"
          >
            <custom-table
              :data="scope.row.partDetails"
              tableCode="parts_location_part_info"
            ></custom-table>
            <span
              class="cell-pop"
              slot="reference"
            >
              <el-button
                type="text"
                size="mini"
              >{{i18n.page_content_view_parts}}</el-button>
            </span>
          </el-popover>
        </template>
        <template v-slot:action="scope">
          <el-button
            type="text"
            size="mini"
            @click="editBtn(scope.row)"
            v-if="funcView.part_location_edit"
          >{{funcView.part_location_edit}}</el-button>
          <el-button
            type="text"
            size="mini"
            v-if="funcView.part_location_delete"
            @click="deleteBtn(scope.row )"
          >{{funcView.part_location_delete}}</el-button>
          <el-button
            type="text"
            size="mini"
            v-if="funcView.part_location_view"
            @click="seeBtn(scope.row)"
          >{{funcView.part_location_view}}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <partsLocation-item-dialog
      v-if="dialogVisible1"
      :data="dialogData1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
      @add="onPageChange({page:1})"
      @edit="onPageChange({page:1})"
    ></partsLocation-item-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import partsLocationItemDialog from './children/partsLocation_item_dialog.vue';

export default {
  name: 'partsLocation',
  components: {
    partsLocationItemDialog,
  },
  data() {
    return {
      tableCode: 'partsLocationList',
      provide: true,
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        partType: '', // 零件类型
      },
      dataTimes: [],
      totalRows: null,
      isLoading: false,
      tableList: [],

      dialogVisible1: false,
      dialogModel1: {},
      dialogData1: {},

      // 按钮状态
      traded: true,
    };
  },
  mounted() {
    // this.getDictionary('asm_part_type');
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.getTableList();
    this.getFuncView();
  },
  methods: {
    checkPartDetail(row) {
      const reqData = {
        productCode: row.productCode,
        componentCode: row.componentCode,
      };
      this.$getJSON(apis.partlocationPartPage, reqData).then((res) => {
        row.partDetails = res.data;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    tableListAdapter(list = []) {
      list.forEach((item) => {
        item.partDetails = [];
      });
      return list;
    },
    getTableList: function () {
      this.$getJSON(apis.partLocationPageList, this.formSearch).then((res) => {
        this.tableList = this.tableListAdapter(res.data.list);
        this.totalRows = res.data.total;
      });
    },
    // 创建零件位置
    addPartItem: function () {
      this.dialogVisible1 = true;
      this.dialogModel1.title = this.i18n.dialog_title_create_part_location;
      this.dialogModel1.type = 'add';
      // this.dialogData1 = regList;
    },

    // 编辑零件位置
    editBtn: function (row) {
      this.dialogVisible1 = true;
      this.dialogModel1.title = this.i18n.dialog_title_edit_part_location;
      this.dialogModel1.type = 'edit';
      this.dialogModel1.data = row;
    },
    seeBtn: function (row) {
      this.dialogVisible1 = true;
      this.dialogModel1.title = this.i18n.dialog_title_view_part_location;
      this.dialogModel1.type = 'watch';
      this.dialogModel1.data = row;
    },
    deleteBtn: function (row) {
      const tips = this.i18n.msg_tips_delete_part_location;
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.partLocationDelete}`, {
          componentCode: row.componentCode,
          productCode: row.productCode,
        }).then(() => {
          this.$message({
            message: this.i18n.com_delete,
            type: 'success',
          });
          this.onPageChange({ page: 1 });
        });
      });
    },
  },
};
</script>

<style lang="scss">
@import '../../../style/colors.scss';
.partsLocation-bd {
}
</style>
